import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CreatePersonComponent } from 'app/dialogs/create-person/create-person.component';
import { CreateWorkerDialogComponent } from 'app/dialogs/create-worker-dialog/create-worker-dialog.component';
import { AuthService } from 'app/services/auth.service';
import { PersonService } from 'app/services/models/person.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-person-list',
  templateUrl: './person-list.component.html',
  styleUrls: ['./person-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PersonListComponent implements OnInit {

  constructor(
    private personService: PersonService,
    private modalService: NgbModal,
    private router: Router,
    private toastrService: ToastrService,
    public authService: AuthService) { }

  @BlockUI('section-block') sectionBlockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;

  isAdvancedChange: boolean = false;

  statusList: any[] = [{ id: null, title: "Hepsi" }, { id: true, title: "Aktif" }, { id: false, title: "Pasif" }]
  status: boolean = true;

  personExcel: any[] = [];
  isPersonsValid: boolean = false;
  allPersonsValid: boolean = true;

  async ngOnInit() {
    this.personService.event$.subscribe(async result => {
      await this.getAllPerson(this.pageBasic - 1, this.selectedSize, this.searchValue, this.status);
    })
    await this.getAllPerson(this.pageBasic - 1, this.selectedSize, this.searchValue, this.status);
  }

  async filterByStatus(event) {
    const filter = event.id;
    console.log(filter);
    this.status = filter
    await this.getAllPerson(this.pageBasic - 1, this.selectedSize, this.searchValue, this.status);
  }

  async getAllPerson(page, size, search, workingStatus) {
    this.sectionBlockUI.start("Personeller yükleniyor..");
    const personAuthorizoton = this.authService.isEndpointStatus('GET.Reading.GetAllPerson');
    if (personAuthorizoton) {
      const data = await this.personService.getAllPersons(page, size, search, workingStatus);
      console.log(data);
      this.rows = data.persons;
      this.totalCount = data.totalCount;
    }
    this.sectionBlockUI.stop();
  }

  onActivate(event: any) {
    const personDetailAuth = this.authService.isEndpointStatus('GET.Reading.GetByIdWorker');
    if (personDetailAuth) {
      if (event.type === 'click' && event.row) {
        this.router.navigate([`/admin/update-worker/${event.row.id}`]);
      }
    }
  }

  filterUpdate(event) {
    const val = event.target.value.toLocaleLowerCase('tr-TR');
    this.searchValue = val;

    setTimeout(async () => {
      this.selectedSize = 50;
      this.basicSelectedOption = this.selectedSize;
      await this.getAllPerson(this.pageBasic - 1, this.selectedSize, this.searchValue, this.status);


    }, 500);
    setTimeout(async () => {
    }, 10000);
  }

  async onPageChange(pageNumber: number) {
    await this.getAllPerson(this.pageBasic - 1, this.selectedSize, this.searchValue, this.status);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllPerson(this.pageBasic - 1, this.selectedSize, this.searchValue, this.status);
  }

  createPerson() {
    const modal = this.modalService.open(CreatePersonComponent, {
      size: 'ml',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      id: null,
      companyId: null
    };
  }

  createWorker() {
    const modal = this.modalService.open(CreateWorkerDialogComponent, {
      size: 'lg',
      centered: true,
      windowClass: 'modal modal-success'
    });
  }

  toggleAdvancedUpload(event: any) {
    this.isAdvancedChange = event.target.checked;
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });

      // İlk sayfayı al
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      // Verileri JSON formatına çevir
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Sütun başlıklarını ayarlamak için
      const persons = jsonData.slice(1).map((row, index) => ({
        name: row[0],
        lastName: row[1],
        mail: row[2],
        phoneNumber: row[3],
        Mission: row[4],
        Depertmant: row[5],
        Tc: row[6],
        workingStatus: row[7]?.toLowerCase() === 'evet',
        wage: row[8],
        birthDay: row[9] ? new Date(Math.round((row[9] - 25569) * 86400 * 1000)) : null,
        emergenyContact: row[10],
        address: row[11],
        startDate: row[12] ? new Date(Math.round((row[12] - 25569) * 86400 * 1000)) : null,
        registrationNumber: row[13],
        rowIndex: index + 2, // Satır numarası (Excel'deki satır için)
        workingDays: row[14]
      }));

      // Tekil kontroller için set'ler
      const tcSet = new Set();
      const phoneNumberSet = new Set();
      const registrationNumberSet = new Set();

      // Hatalı personel kontrolü ve hataları toplama
      const invalidProducts = [];

      persons.forEach(person => {
        const errors = [];

        // Telefon numarası kontrolü (zorunlu değil, varsa 10 veya 11 karakter olmalı)
        if (person.phoneNumber && (!/^\d{10}$/.test(person.phoneNumber))) {
          errors.push('Telefon numarası 10 karakter uzunluğunda ve sadece rakamlardan oluşmalıdır.');
        }

        // Sicil numarası kontrolü (tekil olmalı)
        if (person.registrationNumber && registrationNumberSet.has(person.registrationNumber)) {
          errors.push('Sicil numarası benzersiz olmalı.');
        } else if (person.registrationNumber) {
          registrationNumberSet.add(person.registrationNumber);
        }

        // TC ve telefon numarası tekil olmalı
        if (tcSet.has(person.Tc)) {
          errors.push('TC benzersiz olmalı.');
        } else {
          tcSet.add(person.Tc);
        }

        if (person.phoneNumber && phoneNumberSet.has(person.phoneNumber)) {
          errors.push('Telefon numarası benzersiz olmalı.');
        } else if (person.phoneNumber) {
          phoneNumberSet.add(person.phoneNumber);
        }

        // Hatalı kayıt varsa, hatalar ile birlikte ekle
        if (errors.length > 0) {
          invalidProducts.push({
            rowIndex: person.rowIndex,
            name: person.name || 'Bilinmiyor',
            lastName: person.lastName || 'Bilinmiyor',
            errors,
          });
        }
      });

      // Geçerli personelleri ayarla
      this.isPersonsValid = invalidProducts.length === 0;

      if (invalidProducts.length > 0) {
        // Hata mesajlarını oluştur
        const errorMessages = invalidProducts.map(person => {
          return `Satır ${person.rowIndex} (${person.name} ${person.lastName}): ${person.errors.join(', ')}`;
        });

        // Uyarıyı kullanıcıya göster
        this.toastrService.error(`Hatalar:\n${errorMessages.join('\n')}`, 'Hatalı Kayıtlar', {
          timeOut: 10000,
          extendedTimeOut: 5000,
          closeButton: true,
          enableHtml: true,
        });

        console.error('Hatalı personel detayları:', invalidProducts);
      }

      this.personExcel = persons.filter(person => !invalidProducts.some(p => p.rowIndex === person.rowIndex));

      console.log(this.personExcel);
    };

    reader.readAsBinaryString(file);
  }

  handleDelete(event: MouseEvent) {
    event.stopPropagation();
  }

  resetFileInput(fileInput: HTMLInputElement) {
    // Dosya girişi temizle
    fileInput.value = '';
    this.personExcel = [];
    this.isPersonsValid = false;
    this.allPersonsValid = true;
  }

  async saveProducts() {
    this.sectionBlockUI.start("Personeller yükleniyor..");
    if (!this.isPersonsValid) {
      this.toastrService.error('Lütfen geçerli personelleri yükleyin.');
      return;
    } else {
      this.personExcel = this.personExcel.map(person => {
        const createPerson: any = {
          name: person.name.toString(),
          lastName: person.lastName.toString(),
          mail: person.mail?.toString(),
          phoneNumber: person.phoneNumber?.toString(),
          mission: person.Mission?.toString(),
          depertmant: person.Depertmant?.toString(),
          tc: person.Tc?.toString(),
          workingStatus: person.workingStatus,
          wage: person.wage,
          birthDay: person.birthDay,
          emergenyContact: person.emergenyContact?.toString(),
          address: person.address?.toString(),
          startDate: person.startDate,
          registrationNumber: person.registrationNumber?.toString(),
          workingDays: person.workingDays
        };
        return createPerson;
      });
      const response = await this.personService.createWorkers(this.personExcel);
      if (response.status) {
        this.sectionBlockUI.stop();
        this.toastrService.success(response.message);
        this.personService.sendEvent(true);
      } else {
        this.sectionBlockUI.stop();
        this.toastrService.error(response.message);
      }
    }
  }

  async exportAsExcelFile() {
    const data = await this.exportExcel();
    if (data.length > 0) {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
      const workbook: XLSX.WorkBook = { Sheets: { 'Sheet1': worksheet }, SheetNames: ['Sheet1'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, 'personelListesi.xlsx');
    } else { }
  }

  private saveAsExcelFile(buffer: any, baseFileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(data, baseFileName);
  }

  async exportExcel() {
    const exportedData = [];
    this.rows.forEach(item => {
      console.log(item);
      const formattedStartDate = new Date(item.startDate).toLocaleDateString('tr-TR');
      const rowData = {
        'Adı Soyadı': `${item.name} ${item.lastName}`,
        'SicilNo': item.registrationNumber ?? '',
        'Tel No': item.phoneNumber ?? 'Yok',
        'Görev': item.mission ?? 'Yok',
        'Departman': item.department ?? 'Yok',
        'İşe Başlangıç Tarihi': formattedStartDate,
        'Tc': item.tc,
        'Çalışma Durumu': item.workingStatus ? 'Aktif' : 'Pasif'
      };
      exportedData.push(rowData);
    });
    return exportedData;
  }
}